import React from 'react';
import { Store } from 'lucide-react';

export default function RestauranteDesativado() {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            minHeight: '100vh', 
            backgroundColor: '#f8fafc', 
            padding: '20px', 
            textAlign: 'center', 
            fontFamily: 'system-ui, sans-serif' 
        }}>
            <div style={{ 
                backgroundColor: '#fff', 
                padding: '40px', 
                borderRadius: '24px', 
                boxShadow: '0 10px 25px rgba(0,0,0,0.05)', 
                maxWidth: '400px', 
                width: '100%' 
            }}>
                <div style={{ 
                    backgroundColor: '#fee2e2', 
                    width: '80px', 
                    height: '80px', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    margin: '0 auto 20px' 
                }}>
                    <Store size={40} color="#dc3545" />
                </div>
                <h2 style={{ margin: '0 0 10px 0', color: '#1e293b', fontSize: '24px', fontWeight: '900' }}>Loja Indisponível</h2>
                <p style={{ color: '#64748b', fontSize: '15px', lineHeight: '1.5', margin: '0 0 30px 0' }}>
                    O cardápio que você está tentando acessar está temporariamente desativado.
                </p>
                <button 
                    onClick={() => window.location.reload()} 
                    style={{ 
                        backgroundColor: '#1e293b', 
                        color: '#fff', 
                        border: 'none', 
                        padding: '12px 24px', 
                        borderRadius: '12px', 
                        fontWeight: 'bold', 
                        cursor: 'pointer', 
                        width: '100%' 
                    }}
                >
                    Tentar Novamente
                </button>
            </div>
            <footer style={{ marginTop: '40px', color: '#94a3b8', fontSize: '12px', fontWeight: 'bold' }}>
                © {new Date().getFullYear()} Universo Mídia Digital
            </footer>
        </div>
    );
}